import { render, staticRenderFns } from "./TcTest.vue?vue&type=template&id=9986355e&"
import script from "./TcTest.vue?vue&type=script&lang=js&"
export * from "./TcTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9986355e')) {
      api.createRecord('9986355e', component.options)
    } else {
      api.reload('9986355e', component.options)
    }
    module.hot.accept("./TcTest.vue?vue&type=template&id=9986355e&", function () {
      api.rerender('9986355e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcTest.vue"
export default component.exports